/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React from 'react';
import { Container, CssBaseline, Grid } from '@mui/material';
import useStyles from '../../assets/styles/pages/Promotions';
import Header from '../../components/Header';
import FooterMenuMain from '../../components/FooterMenuMain';

import Promotion from '../../components/Promotion';
import NewPartner from '../../components/NewPartner';
import AskAgain from '../../components/AskAgain';
import NewProduct from '../../components/NewProduct';
import FreeDelivery from '../../components/FreeDelivery';
import DiscountCoupon from '../../components/DiscountCoupon';
import Favorites from '../../components/Favorites';

const Explore: React.FC = () => {
  const classeStyle = useStyles();

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Promotions" />
      <CssBaseline />
      <Grid marginBottom="100px">
        <Promotion />
        <DiscountCoupon />
        <FreeDelivery />
        <Favorites />
        <NewPartner />
        <NewProduct />
        <AskAgain />
      </Grid>
      <FooterMenuMain children="promotions" />
    </Container>
  );
};

export default Explore;
